export default __webpack_public_path__ + "75c4521334e47c6e3303fd93d736832b.gif";